import { useTranslation } from 'react-i18next'

import { LandlordPaymentsTable } from '@features/payments/components/LandlordPaymentsTable'
import { useRents } from '@services/contracts/queires/useRents'

export function LandlordPayments() {
  const { t } = useTranslation('layout')
  // The backend scopes the rents list to the requesting landlord's own flats.
  const { data, isLoading } = useRents()

  return (
    <div className="app-chrome space-y-6">
      <header className="flex items-center gap-3">
        <span
          aria-hidden
          className="h-9 w-1.5 shrink-0 rounded-full bg-gradient-to-b from-primary to-peach"
        />
        <h1 className="m-0 font-display text-2xl font-bold tracking-tight text-ink lg:text-3xl">
          {t('navigation.payments')}
        </h1>
      </header>

      <LandlordPaymentsTable
        rents={data?.results}
        isLoading={isLoading}
        showFlat
      />
    </div>
  )
}
